export default [
  {
    name: 'overview',
    icon: 'pie chart',
    label: 'Overview',
    path: '/',
    roles: ['admin', 'advertiser', 'publisher']
  },
  {
    name: 'search',
    icon: 'search',
    label: 'Search',
    path: '/search',
    roles: ['admin', 'advertiser', 'publisher']
  },
  {
    name: 'exchange',
    icon: 'exchange',
    label: 'Exchange',
    path: '/exchange',
    roles: ['admin', 'bidder']
  },
  {
    name: 'templates',
    icon: 'file alternate outline',
    label: 'Templates',
    path: `${process.env.REACT_APP_CREATIVES_DASHBOARD_URL}/templates`,
    roles: ['admin'],
    externalLink: true
  },
  // NOTE: Publishing Apps page hidden as part of deprecation.
  // The code is preserved but the page is no longer accessible.
  // Remove entirely once confirmed safe to do so.
  // {
  //   name: 'publishing_apps',
  //   icon: 'american sign language interpreting',
  //   label: 'Publishing Apps',
  //   path: '/publishing_apps',
  //   roles: ['admin']
  // },
  {
    name: 'integrations',
    icon: 'internet explorer',
    label: 'Integrations',
    path: '/integrations',
    roles: ['admin']
  },
  {
    name: 'users',
    icon: 'users',
    label: 'Users',
    path: '/users',
    roles: ['admin']
  },
  {
    name: 'creatives',
    icon: 'lightbulb outline',
    label: 'Creatives',
    path: '/creatives',
    roles: ['admin']
  },
  {
    name: 'CBExchangeOverview',
    icon: 'exchange',
    label: 'CBExchange',
    path: '/cb-exchange',
    roles: ['admin']
  },
  {
    name: 'phases',
    icon: 'gem',
    label: 'Rollout Phases',
    path: '/phases',
    roles: ['admin']
  }
];
